const mfScript = "https://mfstatic.com/js/mediaflowplayer.min.js?2";
const mfStyling = "https://mfstatic.com/css/mediaflowplayer.min.css";

var video = (function () {
  function embedVideos() {
    document
      .querySelectorAll(
        ".videoblock .videolink, .utvaltinnehallblock .videolink"
      )
      .forEach(function (elem) {
        var modal =
          elem.parentElement.parentElement.parentElement.querySelector(
            ".modal"
          );

        if (modal) {
          modal.addEventListener("shown.bs.modal", function () {
            resizeEmbeddedVideos();
          });

          modal.addEventListener("hidden.bs.modal", function (event) {
            let video = event.target.querySelector(
              ".modal-body > .video-container > .video"
            );
            video.innerHTML = "";
          });
        }

        elem.onclick = function (event) {
          event.preventDefault();

          var isMediaflowVideo = this.href.indexOf("mediaflow") > -1;

          if (
            !elem.classList.contains("js-videoblock-projektsida") ||
            (elem.classList.contains("js-videoblock-projektsida") &&
              window.innerWidth < window.mdMin)
          ) {
            var url = this.href;
            var container;
            var regExp;
            var youtube = false;
            var vimeo = false;
            var umuPlay = false;

            if (isMediaflowVideo) {
              container = document.createElement("div");
              container.id = "mediaflow-video-" + elem.id;
              container.classList.add("mediaflow-video");
            } else {
              if (url.indexOf("youtu") >= 0) {
                youtube = true;
                regExp =
                  /^(?:https?\:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v\=))([\w-]{10,12})(?:[\&\?\#].*?)*?(?:[\&\?\#]t=(\d+))?$/;
              } else if (url.indexOf("vimeo") >= 0) {
                vimeo = true;
                regExp =
                  /https?:\/\/(?:www\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|album\/(\d+)\/video\/|)(\d+)(?:$|\/|\?|\#)([\w\#\=]*)/;
              } else if (url.indexOf("play.umu") >= 0) {
                umuPlay = true;
                regExp =
                  /https?:\/\/play.umu.se\/media\/(\w+)\/?(\w+)?(?:\w+)?(?:$|\/|\?|\#)?(?:st=)?(\d+)?(?:\&)?(?:ed=)?(\d+)?/;
              }

              var match = url.match(regExp);
              var img = this.querySelector(".videoimage");
              var width = img.clientWidth;
              var height = img.clientHeight;

              if (match && youtube) {
                container = createYoutubeContainer(match, width, height);
              } else if (match && vimeo) {
                container = createVimeoContainer(match, width, height);
              } else if (match && umuPlay) {
                container = createUmuPlayContainer(match, width, height);
              } else {
                container = document.createElement("div");
                container.innerHTML =
                  "<strong>Ingen film kunde hittas</strong>";
              }
            }
          } else {
            return;
          }

          if (
            elem.parentElement.parentElement.parentElement.classList.contains(
              "lightbox"
            ) &&
            window.innerWidth > window.mdMax
          ) {
            if (modal) {
              let video = modal.querySelector(
                ".modal-body > .video-container > .video"
              );
              video.appendChild(container);

              let btn =
                elem.parentElement.parentElement.parentElement.querySelector(
                  ".js-modal-btn"
                );
              btn.click();
            }
          } else {
            if (document.body.classList.contains("mims")) {
              if (this.parentElement.classList.contains("vbss")) {
                let wrapper = document.createElement("div");
                wrapper.classList.add("col-12", "col-lg-6");
                wrapper.appendChild(container);
                this.after(wrapper);
              } else {
                this.after(container);
              }

              container.classList.add("d-block"); // Remove iframe bottom spacing
            } else {
              this.parentElement.appendChild(container);
            }

            this.classList.add("d-none");
          }

          if (isMediaflowVideo) {
            startLoadingScreen(elem.id);

            if (document.querySelector(`script[src='${mfScript}']`)) {
              initMfPlayer(elem);
            } else {
              appendScriptInHead(mfScript, function () {
                const link = document.createElement("link");
                link.rel = "stylesheet";
                link.type = "text/css";
                link.href = mfStyling;
                document.head.append(link);

                initMfPlayer(elem);
              });
            }
          }
        };
      });
  }

  function startLoadingScreen(guid) {
    let mediaflowVideo = document.querySelector("#mediaflow-video-" + guid);
    let loadScreenBackground =
      mediaflowVideo.parentElement.parentElement.querySelector(
        ".video-container > .loadScreenBackground"
      );
    let loadScreen = mediaflowVideo.parentElement.parentElement.querySelector(
      ".video-container > .loadScreen"
    );

    loadScreenBackground.classList.add("show");
    loadScreen.classList.add("show");

    let mediaflowObserver = new MutationObserver((mutationList) =>
      mutationList.forEach((m) => {
        if (
          m.target.className ==
            "plyr__controls__item plyr__time--current plyr__time" &&
          m.target.textContent != "00:00"
        ) {
          //Remove load screen
          loadScreenBackground.classList.remove("show");
          loadScreen.classList.remove("show");
          mediaflowObserver.disconnect();
        }
      })
    );

    mediaflowObserver.observe(mediaflowVideo, {
      childList: true,
      subtree: true,
    });
  }

  function initMfPlayer(elem) {
    var mFPlayer = new MFPlayer(
      "#mediaflow-video-" + elem.id,
      elem.dataset.mediaId,
      elem.id
    );
    mFPlayer.options.autoPlay = elem.dataset.autoplay.toLowerCase() === "true";
    mFPlayer.options.startAt = parseInt(elem.dataset.startAt);
  }

  function createYoutubeContainer(match, width, height) {
    var videoId = match[1];
    var startTidsstampel;

    if (match[2]) {
      startTidsstampel = match[2];
    }

    const src =
      "https://www.youtube.com/embed/" +
      videoId +
      "?autoplay=1" +
      (typeof startTidsstampel !== "undefined" && startTidsstampel !== ""
        ? "&start=" + startTidsstampel
        : "");

    var container = createContainer(src, width, height);
    container.setAttribute("title", "YouTube video player");

    return container;
  }

  function createVimeoContainer(match, width, height) {
    var videoId = match[3];
    var startTidsstampel;

    if (match[4] && match[4].includes("t=")) {
      startTidsstampel = match[4];
      if (match[4].includes("#")) {
        startTidsstampel = match[4].split("#")[1];
      }
    }

    const src =
      "https://player.vimeo.com/video/" +
      videoId +
      "?autoplay=1" +
      (typeof startTidsstampel !== "undefined" && startTidsstampel !== ""
        ? "#" + startTidsstampel
        : "");

    var container = createContainer(src, width, height);

    return container;
  }

  function createUmuPlayContainer(match, width, height) {
    var videoId = match[1];
    if (videoId == "t") {
      videoId = match[2];
    }
    var startTidsstampel;
    if (match[3]) {
      startTidsstampel = match[3];
    }

    var slutTidsstampel;
    if (match[4]) {
      slutTidsstampel = match[4];
    }
    var src =
      "https://api.kaltura.nordu.net/p/296/sp/29600/embedIframeJs/uiconf_id/23449664/partner_id/296?iframeembed=true&playerId=kaltura_player&entry_id=" +
      videoId +
      "&flashvars[autoPlay]=true" +
      (typeof startTidsstampel !== "undefined" && startTidsstampel !== ""
        ? "&flashvars[mediaProxy.mediaPlayFrom]=" + startTidsstampel
        : "") +
      (typeof slutTidsstampel !== "undefined" && slutTidsstampel !== ""
        ? "&flashvars[mediaProxy.mediaPlayTo]=" + slutTidsstampel
        : "");

    var container = createContainer(src, width, height);

    container.setAttribute("ebkitallowfullscreen", "");
    container.setAttribute("mozallowfullscreen", "");
    container.setAttribute("id", "kaltura_player");
    container.setAttribute("title", "Kaltura Player");
    return container;
  }

  function createContainer(src, width, height) {
    let container = document.createElement("iframe");
    container.setAttribute("src", src);
    container.setAttribute("width", width);
    container.setAttribute("height", height);
    container.setAttribute("frameborder", 0);
    container.setAttribute("allow", "autoplay");
    container.setAttribute("allowfullscreen", "");
    return container;
  }

  function resizeEmbeddedVideos() {
    document
      .querySelectorAll(
        "iframe[src*='//player.vimeo.com'], iframe[src*='//www.youtube.com'], iframe[src*='//cdnapisec.kaltura.com']"
      )
      .forEach(function (elem) {
        let newWidth = elem.parentElement.clientWidth;
        let width = elem.clientWidth;

        if (newWidth != width) {
          elem.setAttribute("width", newWidth);
          elem.setAttribute("height", newWidth * 0.5630498533724341); //16:9
        }
      });
  }

  function setupLiveVideos() {
    if (document.querySelector(".livesandning .mfplayer")) {
      const players = document.querySelectorAll(".livesandning .mfplayer");

      // Pure JS version of jQuery getScript
      if (document.querySelector(`script[src='${mfScript}']`)) {
        initMfLive(players);
      } else {
        appendScriptInHead(mfScript, function () {
          const link = document.createElement("link");
          link.rel = "stylesheet";
          link.type = "text/css";
          link.href = mfStyling;
          document.head.append(link);

          initMfLive(players);
        });
      }
    }
  }

  function initMfLive(players) {
    players.forEach(function (p) {
      new MFPlayer("#" + p.id, p.dataset.mediaId, p.id);
    });
  }

  function appendScriptInHead(url, callback) {
    const script = document.createElement("script");
    script.src = url;
    script.onload = callback;
    document.head.append(script);
  }

  function initVideo() {
    embedVideos();
    setupLiveVideos();
    window.addEventListener("resize", resizeEmbeddedVideos);
  }

  return {
    initVideo: initVideo,
  };
})();

export default video;
